export const getFilteredProject = (project) => ({
    id: project.id,
    internalAppId: project.internalAppId,
    translations: project.translations,
    city: project.city,
    projectType: project.projectType,
    agentFirstName: project.agent?.[0]?.firstName,
    agentLastName: project.agent?.[0]?.lastName,
})
